import { Component } from '@angular/core';
import { LegalWheelSection } from '../../shared/ui/legal-wheel/legal-wheel.component';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: 'privacyPolicy.component.html'
})
export class PrivacyPolicyComponent {
  lastUpdated = 'September 2026';

  
  sections: LegalWheelSection[] = [
    {
      title: '1. Information we collect',
      body: `<p>Depending on how a given property configures VOWEL, we may process:</p>
        <ul>
          <li><strong>Identity details:</strong> full name, gender, nationality, and an identification document type and number (e.g. National ID, driving licence, passport).</li>
          <li><strong>Contact details:</strong> phone number, dialing code, and email address.</li>
          <li><strong>Visit details:</strong> purpose of visit, host/employee being visited, company or service provider represented, check-in and check-out timestamps, and gate pass or reference numbers.</li>
          <li><strong>Vehicle details:</strong> vehicle registration number, make/model, and driver details where a vehicle is logged.</li>
          <li><strong>Photos:</strong> a photo captured at check-in, where the property enables this feature.</li>
          <li><strong>Account and device information:</strong> username, role, account/property association, and, for bound kiosk or mobile devices, device identifiers used to authorize check-in hardware.</li>
          <li><strong>Usage information:</strong> login timestamps, and pages/actions taken within the admin console, for security and audit purposes.</li>
        </ul>`,
    },
    {
      title: '2. Why we process this information',
      body: `<ul>
          <li>To operate access control and check-in/check-out at the property (the core purpose of the platform).</li>
          <li>To maintain an audit trail of who entered a property, when, and why, for security and incident investigation.</li>
          <li>To notify hosts, security personnel, or account administrators of visitor arrivals, overdue visitors, flagged individuals, or panic/security events.</li>
          <li>To generate reports requested by the property (e.g. exited visitor reports, vehicle reports, audit trail reports).</li>
          <li>To authenticate users and secure accounts against unauthorized access.</li>
        </ul>`,
    },
    {
      title: '3. Who this information is shared with',
      body: `<p>
          Visitor and staff data entered against a given property is visible to that property's authorized
          administrators and security personnel only — it is not shared across unrelated properties or
          accounts. We do not sell personal information to third parties or use it for advertising. Limited
          technical service providers (such as hosting and notification infrastructure) may process data on
          our behalf, solely to operate the platform, and are bound to keep it confidential.
        </p>`,
    },
    {
      title: '4. How long we keep it',
      body: `<p>
          Visit records are generally retained for as long as the property account remains active, to
          support historical reporting and audit requirements, after which they are deleted or anonymized
          on a schedule set by the property administrator or applicable local record-keeping requirements.
          Device-local data (such as a "last login" convenience shown on this device) stays only in your
          browser and is never transmitted to us.
        </p>`,
    },
    {
      title: '5. Security',
      body: `<p>
          Access to visitor and account data is restricted by role-based permissions, and authentication
          uses signed session tokens. While we take reasonable technical and organizational measures to
          protect information, no system can be guaranteed 100% secure, and we encourage account
          administrators to safeguard their login credentials and review user access regularly.
        </p>`,
    },
    {
      title: '6. Your rights',
      body: `<p>
          If you believe a property has recorded information about you and would like to access, correct,
          or request deletion of it, please contact that property's front desk or account administrator
          directly, as they control the underlying data. For questions about how the VOWEL platform itself
          handles data, you can reach us at <a href="mailto:di.support@compulynx.com">di.support@compulynx.com</a>.
        </p>`,
    },
    {
      title: '7. Children',
      body: `<p>
          VOWEL is intended for use by property staff, residents, employees and adult visitors. It is not
          directed at children, though a minor's basic visit details may be recorded incidentally where a
          property requires all visitors, regardless of age, to check in for security reasons.
        </p>`,
    },
    {
      title: '8. Changes to this policy',
      body: `<p>
          We may update this Privacy Policy from time to time to reflect changes in the platform or
          applicable law. Material changes will be reflected by updating the "Last updated" date above.
        </p>`,
    },
  ];
}
